import { ContentBody } from 'components/pages/components/ContentBody'
import { componentPermissions } from 'config/permissions'
import { componentNames } from 'config/roles'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { RoutePaths } from 'routes/paths'

const OrganizationManagement: FC = () => {
  const { t } = useTranslation()

  return <ContentBody title={t('organizationManagement.title')}></ContentBody>
}

const exportObj = {
  routeProps: {
    // This gets passed straight to react-router
    path: RoutePaths.organizationManagement,
    index: true,
    title: 'pages.organizationManagement',
    element: <OrganizationManagement />,
    roles:
      componentPermissions[componentNames.pageManagementOrganizationManagement],
    requiresAuthentication: true,
  },
  name: 'OrganizationManagement',
}
export default exportObj
